/**
 * Created by ZXW on 2018/2/28.
 */
import router from '../router'
import { Message } from 'element-ui'

// 注意封面图片接口地址直接写在了vue，必要时请替换
const LoginUrl = {
  getCode: 'm/sysUser/getAuthCode',
  login: 'm/sysUser/doLogin',
  resetPwd: '/m/sysUser/updatePwd',
  getPulicKey: '/m/sysUser/web/getPublicKey'
}
const SettingUrl = { // c简写为custom,a简写为adver
  cList: 'm/zxAdvertiseSupplier/listByPage',
  cSave: 'm/zxAdvertiseSupplier/save',
  cUpdate: 'm/zxAdvertiseSupplier/update',
  cDel: 'm/zxAdvertiseSupplier/delete',
  aList: 'm/zxAdvertisePosition/listByPage',
  aSave: 'm/zxAdvertisePosition/save',
  aUpdate: 'm/zxAdvertisePosition/update',
  aDel: 'm/zxAdvertisePosition/delete'
}
const Other = {
  allCustom: 'm/zxAdvertiseSupplier/list',
  fmPic: 'upload/uploadFile2Oss', // 封面上传
  editPic: 'upload/areaFiles', // 富文本图片上传
  allRole: 'm/sysRole/list',
  allDics: 'm/sysDict/list'
}

const SystemUrl = { // a为账号管理
  aList: 'm/sysUser/findListPageGroupByUser',
  aSave: 'm/sysUser/save',
  aUpdate: 'm/sysUser/update',
  aDel: 'm/sysUser/delete',
  aDetail: 'm/sysUser/detail',
  updatePwd: 'm/sysUser/updatePwd',
  rList: 'm/sysRole/listByPage',
  rSave: 'm/sysRole/saveRoleMenu',
  rUpdate: 'm/sysRole/updateRoleMenu',
  rDetail: 'm/sysRole/detailRoleAndMenu',
  rDel: '/m/sysRole/delete',
  dList: 'm/sysDict/listByPage',
  dSave: 'm/sysDict/save',
  dUpdate: 'm/sysDict/update',
  dDel: 'm/sysDict/delete',
  menuTree: 'm/sysMenu/findAllMenus',
  saveMenu: 'm/sysMenu/save',
  updateMenu: 'm/sysMenu/update',
  delMenu: 'm/sysMenu/delete'
}

const AdInfoUrl = {
  aList: 'm/zxAdvertiseInfo/listByPage',
  aSave: 'm/zxAdvertiseInfo/save',
  aUpdate: 'm/zxAdvertiseInfo/update',
  aDel: 'm/zxAdvertiseInfo/delete',
  applyCheck: 'm/zxAdvertiseInfo/applyCheck',
  batchApply: 'm/zxAdvertiseInfo/applyCheckBatch',
  revoke: 'm/zxAdvertiseInfo/revoke',
  off: 'm/zxAdvertiseInfo/off',
  on: '/m/zxAdvertiseInfo/putaWay',
  checkRecord: 'm/zxAdvertiseDealRecord/list',
  moveAd: 'm/zxAdvertiseInfo/upOrDown',
  topAd: '/m/zxAdvertiseInfo/placeTopByPositionId',
  shelvesAd: '/m/zxAdvertiseInfo/soldOutBatchList',
  delAd: '/m/zxAdvertiseInfo/deleteBatchList'
}

const adCheckUrl = {
  aList: 'm/zxAdvertiseInfo/listcheckedByPage',
  aaList: 'm/zxAdvertiseInfo/listRecheckedByPage',
  check: 'm/zxAdvertiseDealRecord/save',
  checkAll: '/m/zxAdvertiseInfo/directlyOnBatchList'
}

export default {
  Other,
  LoginUrl,
  SettingUrl,
  SystemUrl,
  AdInfoUrl,
  adCheckUrl,
  overdue: function (code, msg) {
    if (code === 545) {
      Message.error('登录过期,请重新登录!')
      sessionStorage.removeItem('token')
      router.push('/login')
    } else {
      Message.error(msg || '系统异常,请重试!')
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/interface.js